import React from 'react';
import { Box, Container, Typography, Grid, Link as MuiLink } from '@mui/material';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import SectionHeading from '../../components/SectionHeading';
import { colors } from '../../theme';
import { ease } from '../../utils/animations';
import { track } from '../../utils/analytics';

// Verbatim from the Google reviews, trimmed only where marked with an ellipsis.
const REVIEWS = [
    {
        quote:
            'Paul and his team built our app from scratch for an FDA registered medical ' +
            'device that helps a stroke survivor stand up and practice walking in place. ' +
            'The app took readings from the machine and provided a user experience that ' +
            'helped their recovery and helped their caregivers track progress… We will be ' +
            'doing ongoing projects with minneAI.',
        name: 'Dale Willenbring',
    },
    {
        quote:
            'Working with Paul far surpassed all expectations! His knowledge and expertise ' +
            'helped guide me through all my questions, with viable solutions for my ' +
            'business. Very pleased and highly recommend!',
        name: 'Leslie Smith',
    },
];

const Stars = () => (
    <Box sx={{ display: 'flex', gap: 0.4, mb: 2.5 }} aria-label="Five out of five stars">
        {Array.from({ length: 5 }, (_, i) => (
            <Star key={i} size={17} color={colors.green} fill={colors.green} />
        ))}
    </Box>
);

const Testimonials = () => (
    <Box component="section" id="testimonials" sx={{ backgroundColor: '#f6f8f7', py: { xs: 9, md: 13 } }}>
        <Container maxWidth="lg">
            <SectionHeading
                eyebrow="Clients"
                title="In their words."
                sx={{ mb: { xs: 4, md: 6 } }}
            />

            <Grid container spacing={{ xs: 5, md: 7 }}>
                {REVIEWS.map((r, i) => (
                    <Grid size={{ xs: 12, md: 6 }} key={r.name}>
                        <motion.div
                            initial={{ opacity: 0, y: 22 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.65, delay: i * 0.1, ease }}
                        >
                            <Stars />
                            <Typography
                                sx={{
                                    fontWeight: 300,
                                    fontSize: 'clamp(1.05rem, 1.7vw, 1.3rem)',
                                    lineHeight: 1.65,
                                    color: '#111',
                                    mb: 2.5,
                                }}
                            >
                                &ldquo;{r.quote}&rdquo;
                            </Typography>
                            <Typography sx={{ fontSize: '0.95rem', fontWeight: 600, color: '#111' }}>
                                {r.name}
                            </Typography>
                            <Typography sx={{ fontSize: '0.82rem', color: 'text.secondary', mt: 0.25 }}>
                                Google review
                            </Typography>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>

            <MuiLink
                href="https://maps.google.com/?cid=15962025236700814684"
                target="_blank" rel="noopener"
                onClick={() => track('outbound_click', { item: 'google_reviews', source: 'testimonials' })}
                sx={{
                    display: 'inline-block', mt: { xs: 5, md: 6 }, fontSize: '0.95rem', fontWeight: 600,
                    color: colors.greenText, textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                }}
            >
                Read the reviews on Google →
            </MuiLink>
        </Container>
    </Box>
);

export default Testimonials;
